// extracted by mini-css-extract-plugin
export var acceptButton = "_1o-5";
export var fullContent = "_1o-4";
export var link = "_1o-6";
export var linkIcon = "_1o-7";
export var sideContent = "_1o-3";
export var sideImage = "_1o-2";
export var sideImageWrapper = "_1o-1";
export var splitLayout = "_1o-0";